import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import withGlobals from '../../withGlobals';
import { push } from 'react-router-redux';
import compact from 'lodash/compact';
import get from 'lodash/get';
import omit from 'lodash/omit';
import seo from 'shared/lib/seo';
import {
  saveBaggageLocation,
  saveBaggageAirline,
  saveBaggageConfirmationViewNumber,
  getAirlines,
  saveBaggagePassengerInfo,
  getBaggagePlansView,
  selectBaggagePlan,
  checkoutBaggagePlan,
  purchaseBaggage,
  showMenu,
  hideMenu,
} from '../../store/actions';
import { getDisclaimer } from 'shared/lib/utils';
import TopNavBar from '../../components/TopNavBar';

class BaggageContainer extends Component {
  componentDidMount() {
    seo.setProps({
      title: 'Lost Baggage, Luggage & Suitcase Insurance | Sure',
      description:
        'Get Baggage Insurance through Sure to protect your baggage, luggage, and suitcases when you travel. Plans starting at $5 per trip.',
      url: 'https://www.sureapp.com/baggage-protection',
    });
    this.props.getAirlines();
  }

  render() {
    const { children } = this.props;
    return (
      <div className="BaggageContainer">
        {compact(this.props.location.pathname.split('/')).length > 1 && (
          <TopNavBar
            isLoggedIn={this.props.isLoggedIn}
            userFullName={this.props.userFullName}
            isMenuOpen={this.props.isMenuOpen}
            activeLink={this.props.location.pathname}
            onHideMenu={this.props.hideMenu}
            onShowMenu={this.props.showMenu}
          />
        )}
        {React.cloneElement(children, omit(this.props, ['children']))}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoggedIn: !!state.authToken,
    userFullName: `${state.account.firstName} ${state.account.lastName}`,
    isMenuOpen: state.isMenuOpen,

    account: state.account,
    airlines: state.airlines,
    baggageAirline: state.baggageAirline,
    baggageCheckout: state.baggageCheckout,
    baggageConfirmationNumber: '' + state.baggageConfirmationNumber,
    baggageLocation: state.baggageLocation,
    baggagePassengerInfo: state.baggagePassengerInfo,
    baggagePlans: state.baggagePlans,
    baggagePurchase: state.baggagePurchase,
    baggageSettings: state.baggageSettings,
    disclaimer: getDisclaimer(state.baggagePlans, 'Blue Ribbon Bags, LLC.'),
    isBaggageInProgress: state.isBaggageInProgress,
    baggageSelectedPlanId: state.baggageSelectedPlanId,
    totals: get(state.baggageCheckout, 'totals'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        getAirlines,
        getBaggagePlansView,
        hideMenu,
        navTo: push,
        saveBaggageLocation,
        saveBaggageAirline,
        saveBaggageConfirmationViewNumber,
        saveBaggagePassengerInfo,
        selectBaggagePlan,
        checkoutBaggagePlan,
        purchaseBaggage,
        showMenu,
      },
      dispatch
    ),
  };
};

const enhance = compose(
  withGlobals({
    analyticsPrefix: 'BRB',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(BaggageContainer);
